import { Routes, Route, Navigate } from "react-router-dom";

// Importe todas as suas páginas aqui
import Inicio from "../pages/inicio";
import Oportunidades from "../pages/Oportunidades";
import OpportunityEditorPage from "../pages/OpportunityEditorPage";
import Sobre from "../pages/Sobre";
import Blog from "../pages/Blog";
import BlogArticle from "../pages/BlogArticle";
import Biblioteca from "../pages/Biblioteca";
import BibliotecaDocument from "../pages/BibliotecaDocument";
import LoginPage from "../pages/LoginPage";
import RegisterPage from "../pages/RegisterPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import UserProfile from "../pages/UserProfile";
import AdminPage from "../pages/AdminPage";
import NewsletterCancelar from "../pages/NewsletterCancelar";

// Componente para rotas protegidas
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('authToken');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Componente para rotas que requerem permissão de admin
const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('authToken');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  // Aqui podemos adicionar verificação adicional de role se necessário
  return children;
};

export default function AppRoutes() {
  return (
    <Routes>
      {/* A rota principal "/" renderiza a sua página Inicio */}
      <Route path="/" element={<Inicio />} />
      
      {/* Outras rotas */}
      <Route path="/oportunidades" element={<Oportunidades />} />
      <Route path="/biblioteca" element={<Biblioteca />} />
      <Route path="/biblioteca/:idOrSlug" element={<BibliotecaDocument />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:idOrSlug" element={<BlogArticle />} />
      <Route path="/oportunidades/nova" element={
        <ProtectedRoute>
          <OpportunityEditorPage mode="create" />
        </ProtectedRoute>
      } />
      <Route path="/oportunidades/:id/editar" element={
        <ProtectedRoute>
          <OpportunityEditorPage mode="edit" />
        </ProtectedRoute>
      } />
      <Route path="/sobre" element={<Sobre />} />
      <Route path="/newsletter/cancelar" element={<NewsletterCancelar />} />
      
      {/* Rotas de autenticação */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/esqueci-senha" element={<ForgotPasswordPage />} />
      <Route path="/redefinir-senha" element={<ResetPasswordPage />} />
      
      {/* Rotas protegidas */}
      <Route path="/perfil" element={
        <ProtectedRoute>
          <UserProfile />
        </ProtectedRoute>
      } />
      
      {/* Rota de administração */}
      <Route path="/admin" element={
        <AdminRoute>
          <AdminPage />
        </AdminRoute>
      } />
      
      {/* Quando precisar adicionar uma nova página, você só precisará mexer aqui */}
      {/* Exemplo: <Route path="/contato" element={<Contato />} /> */}
    </Routes>
  );
}
